import {
  Apps20Regular,
  ErrorCircle20Regular,
  PauseCircle20Regular,
  Payment20Regular,
  PeopleTeam20Regular,
  PersonAdd20Regular,
  PersonAvailable20Regular,
  PlugConnected20Regular,
  Receipt20Regular,
  ShieldPerson20Regular,
  WalletCreditCard20Regular,
} from '@/components/Icon'

/** Placeholder metrics until user directory APIs exist. */
export const USERS_KPI = [
  { value: 24, label: 'Total users', caption: 'Across your organization', LabelIcon: PeopleTeam20Regular },
  { value: 18, label: 'Active this week', caption: 'Signed in at least once', LabelIcon: PersonAvailable20Regular },
  { value: 3, label: 'Pending invites', caption: 'Awaiting acceptance', LabelIcon: PersonAdd20Regular },
  { value: 4, label: 'Elevated roles', caption: 'Admins and billing owners', LabelIcon: ShieldPerson20Regular },
]

/** Placeholder metrics until billing APIs exist. */
export const BILLING_KPI = [
  { value: '$4,280', label: 'Monthly spend', caption: 'Current billing period total', LabelIcon: Payment20Regular },
  { value: 2, label: 'Open invoices', caption: 'Awaiting payment or review', LabelIcon: Receipt20Regular },
  { value: 1, label: 'Payment method', caption: 'Card on file for auto-pay', LabelIcon: WalletCreditCard20Regular },
]

/** Placeholder metrics until connection directory APIs exist. */
export const CONNECTIONS_KPI = [
  { value: 6, label: 'Connected apps', caption: 'OAuth and workspace integrations', LabelIcon: Apps20Regular },
  { value: 5, label: 'Active', caption: 'Healthy sync in the last 24 hours', LabelIcon: PlugConnected20Regular },
  { value: 1, label: 'Failed', caption: 'Needs attention or re-authorization', LabelIcon: ErrorCircle20Regular },
  { value: 2, label: 'Disabled', caption: 'Paused by admin or user', LabelIcon: PauseCircle20Regular },
]
